export const getReaches = (state) => state.reaches
export const getReachesMeta = (state) => state.meta_data
export const getReachStatus = (state) => state.status